export enum UserRole {
  MANAGER_UPLOAD = "manager-upload",
  TASK_OWNER = "task-owner",
}

export enum CognitoClaim {
  USERNAME = "cognito:username",
  TENANT_NAME = "custom:tenant_name",
  TENANT_ID = "custom:tenant_id",
  ROLE = "custom:role",
  ENVIRONMENT = "custom:environment",
}

export interface ManagerProfileFund {
  fund_id: string;
  fund_name: string;
  is_index: boolean;
  latest_date: string;
}

export interface ManagerProfile {
  manager_id: string;
  manager_name: string;
  email: string;
  is_fund_owner: boolean;
  image?: string;
  funds?: ManagerProfileFund[];
}

export interface User {
  isAuthenticated: boolean;
  sub: string;
  "custom:tenant_name": string;
  iss: string;
  "cognito:username": string;
  "custom:tenant_id": string;
  given_name: string;
  origin_jti: string;
  aud: string;
  event_id: string;
  token_use: string;
  auth_time: number;
  exp: number;
  "custom:role": UserRole | string;
  iat: number;
  family_name: string;
  "custom:environment": string;
  jti: string;
  email: string;
  managerProfile?: ManagerProfile;
}

export interface UserSimple {
  username: string;
  name: string;
  email: string;
  role: string;
  tenant: string;
}
